import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

// Employees with disciplinary action trend
const getDisciplinaryActionsReportedEmployeesGraphData = async (options) => {
  const url = endpoints.disciplinaryActions.getDisciplinaryActionsGraph;
  try {
    const response = await sendRequest({
      url,
      method: 'POST',
      body: options,
      queryParams: {
        graphType: 'BAR',
      },
      credentials: 'include',
    });

    return response;
  } catch (error) {
    console.log('Error loading reported employees data', error);
    throw error;
  }
};

export const useGetDisciplinaryActionsReportedEmployeesGraphData = (options) =>
  useQuery({
    queryKey: [
      REACT_QUERY_KEYS.disciplinaryActions.getDisciplinaryActionsReportedEmployeeGraph,
      options.baseFilter.startDate,
      options.baseFilter.endDate,
      options.baseFilter.companyId.join(','),
      options.baseFilter.location.join(','),
    ],
    queryFn: () => getDisciplinaryActionsReportedEmployeesGraphData(options),
  });

// Employees by Violation Count (%)
const getDisciplinaryActionsViolationCountGraphData = async (options) => {
  const url = endpoints.disciplinaryActions.getDisciplinaryActionsGraph;
  try {
    const response = await sendRequest({
      url,
      method: 'POST',
      body: options,
      queryParams: {
        graphType: 'TREND_LINE',
      },
      credentials: 'include',
    });
    return response;
  } catch (error) {
    console.log('Error loading violation count data', error);
    throw error;
  }
};

export const useGetDisciplinaryActionsViolationCountGraphData = (options) =>
  useQuery({
    queryKey: [
      REACT_QUERY_KEYS.disciplinaryActions.getDisciplinaryActionsViolationCountGraph,
      options.baseFilter.startDate,
      options.baseFilter.endDate,
      options.baseFilter.companyId.join(','),
      options.baseFilter.location.join(','),
    ],
    queryFn: () => getDisciplinaryActionsViolationCountGraphData(options),
  });
